export default "__VITE_ASSET__CXGO8u1Q__"